/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Portals_CommercialInputs */

const cs_property_portals_commercial = /** @type {(inputs: Property_Portals_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchodní příznaky inzerátu`)
};

const en_property_portals_commercial = /** @type {(inputs: Property_Portals_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing & commercial flags`)
};

/**
* | output |
* | --- |
* | "Listing & commercial flags" |
*
* @param {Property_Portals_CommercialInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_portals_commercial = /** @type {((inputs?: Property_Portals_CommercialInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Portals_CommercialInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_portals_commercial(inputs)
	return cs_property_portals_commercial(inputs)
});